"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./ProseLayout.scss");
var _renderDownloadIcon = _interopRequireDefault(require("../../utils/renderDownloadIcon"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _FocusedImage = _interopRequireDefault(require("../FocusedImage/FocusedImage"));
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/formatSpecialCharText"));
var _generateFocusedImageAlt = _interopRequireDefault(require("../../utils/generateFocusedImageAlt"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const imageSizes = {
  desktop: {
    width: 1280,
    height: 330,
    ratio: {
      width: 128,
      height: 33
    }
  },
  tablet: {
    width: 960,
    height: 300,
    ratio: {
      width: 48,
      height: 15
    }
  },
  mobile: {
    width: 360,
    height: 115,
    ratio: {
      width: 72,
      height: 23
    }
  }
};
const ProseLayout = _ref => {
  let {
    bannerBelowHeader,
    bannerImage,
    header,
    subheader,
    listPageLink,
    date,
    content,
    resources,
    sources,
    paddingClass,
    industryOrCategory,
    industriesOrCategories,
    Link,
    authorBioComponent,
    contentType
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `prose-container ${paddingClass}`
  }, bannerImage?.focalPointImage && /*#__PURE__*/_react.default.createElement("div", {
    className: `banner-image-container ${bannerBelowHeader ? "low-banner" : ""}`
  }, /*#__PURE__*/_react.default.createElement(_FocusedImage.default, {
    focalPointImage: bannerImage?.focalPointImage,
    alt: (0, _generateFocusedImageAlt.default)(bannerImage),
    fullHeightWrapper: true,
    imageSizes: imageSizes
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: `article-head inner-padding ${bannerBelowHeader ? "high-header" : ""}`
  }, listPageLink && /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    className: "back-to-list",
    to: listPageLink
  }, "Back to full list"), industryOrCategory?.name && /*#__PURE__*/_react.default.createElement("div", {
    className: "category"
  }, industryOrCategory.name), industriesOrCategories?.length && /*#__PURE__*/_react.default.createElement("div", {
    className: "category-container"
  }, industriesOrCategories.map(industryOrCategory => /*#__PURE__*/_react.default.createElement("div", {
    className: "category",
    key: `category-${industryOrCategory.name}`
  }, industryOrCategory.name))), contentType && /*#__PURE__*/_react.default.createElement("span", {
    className: "content-type"
  }, contentType), header && /*#__PURE__*/_react.default.createElement("h1", {
    className: "header",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(header)
  }), authorBioComponent && /*#__PURE__*/_react.default.createElement("div", {
    className: "article-author"
  }, authorBioComponent), subheader && /*#__PURE__*/_react.default.createElement("div", {
    className: "sub-header"
  }, subheader)), /*#__PURE__*/_react.default.createElement("div", {
    className: "body inner-padding"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, content)), resources && /*#__PURE__*/_react.default.createElement("div", {
    className: "additional-resources inner-padding"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "section-header"
  }, "Additional Resources"), resources.map((resource, index) => resource?.file?.url && /*#__PURE__*/_react.default.createElement("div", {
    className: "resource",
    key: `resource-${index}`
  }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    Link: Link,
    to: resource.file.url,
    ariaLabel: `Download ${resource?.file?.contentType ? `${resource?.file?.contentType} version of ` : ""}${resource?.description ? resource?.description : "file"}`
  }, resource?.description || "resource"), (0, _renderDownloadIcon.default)("#000000", "33")))), sources && /*#__PURE__*/_react.default.createElement("div", {
    className: "sources inner-padding"
  }, sources.map((source, index) => /*#__PURE__*/_react.default.createElement("div", {
    className: "source",
    key: `source-${index}`
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "label"
  }, "Source:\xA0"), /*#__PURE__*/_react.default.createElement("span", {
    className: "source-content"
  }, source)))));
};
var _default = ProseLayout;
exports.default = _default;